import Vue from 'vue'
// import { Message } from 'element-ui'

/**
 * 读取componetns/base下的vue文件并自动注册全局组件
 */
const requireComponent = require.context('../components/base', false, /\.vue$/)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = fileName.replace(/^\.\//, '').replace(/\.vue/, '')

  Vue.component(componentName, componentConfig.default || componentConfig)
})

// 全局函数
// const success = () =>
//   Message({
//     message: '提交成功',
//     type: 'success'
//   })

// const error = () =>
//   Message({
//     message: '提交失败,请稍后重试或联系相关管理员',
//     type: 'error'
//   })
